import React, {Component} from 'react';
import PropTypes from "prop-types";

export default class IncomeDetail extends Component {
  static propTypes = {
    img: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    amount: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className={'income-detail'}>
        <img alt={'icon'} src={this.props.img}/>
        <div className={'content'}>
          <h4>{this.props.title}</h4>
          <p>{this.props.description}</p>
        </div>
        <div className='point-holder'>
          <li>
            <span title={this.props.amount}>{this.props.amount}</span>
            <p title={this.props.unit}>{this.props.unit}</p>
          </li>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/elements/IncomeDetail.js